import { render, staticRenderFns } from "./FrmManageOrders.vue?vue&type=template&id=389782e6"
import script from "./FrmManageOrders.vue?vue&type=script&lang=js"
export * from "./FrmManageOrders.vue?vue&type=script&lang=js"
import style0 from "./FrmManageOrders.vue?vue&type=style&index=0&id=389782e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports